import React, {Component} from "react";
import axios from "axios";
import { Menu, Tooltip} from "antd";
import MovingElement from "../BuildCube/MovingElement";
import {Icon} from "@ant-design/compatible"
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const rootSubmenuKeys = ['datasource', 'algorithm', 'model'];

class ProjectMenu extends Component {

  state = {
    openKeys: [],
    systemDataSource: new Map(),
    selfDataSource: new Map(),
    algorithms: [],
    systemModel: new Map(),
    selfModel: new Map()
  };

  constructor() {
    super();
    this.fetchData = this.fetchData.bind(this);
    this.parseData = this.parseData.bind(this);
    this.renderDataSource = this.renderDataSource.bind(this);
    this.renderAlgorithm = this.renderAlgorithm.bind(this);
    this.renderModel = this.renderModel.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  render() {

    const windowWidth = window.innerWidth;

    return (
      <Menu
        onClick={this.handleClick}
        // style={{width: 240}}
        mode="inline"
        selectable={false}
        inlineCollapsed={false}
        openKeys={this.state.openKeys}
        onOpenChange={this.onOpenChange}
      >
        <SubMenu key="datasource" title={<span><Icon type="mail"/><span>数据集</span></span>}>
          <MenuItemGroup key="datasource-group-1" title="我的数据集">
            {this.renderDataSource(false)}
          </MenuItemGroup>
          <MenuItemGroup key="datasource-group-2" title="系统数据集">
            {this.renderDataSource()}
          </MenuItemGroup>
        </SubMenu>
        <SubMenu key="algorithm" title={<span><Icon type="appstore"/><span>算法</span></span>}>
          {
            this.renderAlgorithm(this.state.algorithms)
          }
        </SubMenu>
        <SubMenu key="model" title={<span><Icon type="setting"/><span>已训练模型</span></span>}>
          <MenuItemGroup key="model-group-1" title="我的模型">
            {
              this.renderModel(false)
            }
          </MenuItemGroup>
          <MenuItemGroup key="model-group-2" title="系统数据集">
            {
              this.renderModel()
            }
          </MenuItemGroup>
        </SubMenu>
      </Menu>
    )
  }

  fetchData() {
    axios({
      url: `/api-bigdata/datasets?system=true`,
      method: "GET"
    }).then(
      response => {
        let systemDataSource = this.parseData(response);
        this.setState({systemDataSource});
      }
    ).then(
      response => {
        return axios({
          url: `/api-bigdata/datasets?system=false`,
          method: "GET"
        })
      }
    ).then(
      response => {
        let selfDataSource = this.parseData(response);
        this.setState({selfDataSource});
      }
    ).then(
      response => {
        return axios({
          url: `/api-algorithm/getAlgorithmTree?name=`,
          method: "GET"
        })
      }
    ).then(
      response => {
        console.debug("algorithm tree:", response.data);
        this.setState({
          algorithms: response.data
        })
      }
    ).then(
      response => {
        return axios({
          url: `/api-bigdata/models?system=true`,
          method: "GET"
        })
      }
    ).then(
      response => {
        let systemModel = this.parseData(response);
        this.setState({systemModel});
      }
    ).then(
      response => {
        return axios({
          url: `/api-bigdata/models?system=false`,
          method: "GET"
        })
      }
    ).then(
      response => {
        let selfModel = this.parseData(response);
        this.setState({selfModel})
      }
    ).catch(
      ex => {
        console.error("/api-bigdata/datasets?system=true exception:", ex);
      }
    )
  }

  parseData(response) {
    let category = "";
    let m = new Map();
    for (let index = 0; index < response.data.length; index++) {
      const cat = response.data[index].category.code;
      if (cat !== category) {
        let arr = [];
        arr.push(response.data[index]);
        m.set(cat, arr);
        category = cat;
      }
      else {
        m.get(cat).push(response.data[index]);
      }
    }
    console.debug("parseData:", m);
    return m;
  }

  renderDataSource(isSystem=true) {
    let dataSourcePart = [];
    let dataSource = this.state.systemDataSource;
    if (!isSystem) {
      dataSource = this.state.selfDataSource;
    }
    dataSource.forEach((v, k) => {
      dataSourcePart.push(
        <SubMenu key={`${k}|${isSystem ? "systemDataSource" : "selfDataSource"}`} title={v[0].category.name}>
          {
            v.map(ele => (
              <Menu.Item key={ele.id}>
                {/*TODO: whether we need ele.id here*/}
                <MovingElement elId={ele.id} name={ele.name} type="dataSet"/>
              </Menu.Item>
            ))
          }
        </SubMenu>
      )
    });
    return dataSourcePart;
  }

  renderAlgorithm(data) {
    return data.map(branch => {
      if (!branch.isAlgorithm && branch.children.length !== 0) {
        return (
          <SubMenu key={branch.key} title={branch.label}>
            {
              this.renderAlgorithm(branch.children)
            }
          </SubMenu>
        )
      } else {
        return (
          <Menu.Item key={branch.key}>
            <MovingElement elId={branch.key} name={branch.label} type="algorithm" logo={branch.logo}/>
          </Menu.Item>
        )
      }
    })
  }

  renderModel(isSystem=true) {
    let modelPart = [];
    let models = this.state.systemModel;
    if (!isSystem) {
      models = this.state.selfModel;
    }
    models.forEach((v, k) => {
      modelPart.push(
        <SubMenu key={`${k}|${isSystem ? "systemModel" : "selfModel"}`} title={v[0].category.name}>
          {
            v.map(ele => (
              <Menu.Item key={ele.id}>
                {/*TODO: whether we need ele.id here*/}
                <MovingElement elId={ele.id} name={ele.name} type="model"/>
              </Menu.Item>
            ))
          }
        </SubMenu>
      )
    });
    return modelPart;
  }

  onOpenChange(openKeys) {
    console.log("openKeys:", openKeys);
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      });
    }
  }
}

export default ProjectMenu;
